import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }

import { ref } from 'vue'
// import { getStarvingRecord} from '@/service/main/statistical';
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportJson2Excel, formatJson } from "@/utils/excel";
import Pagination from '@/components/Pagination/index.vue'
//查询

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formModel = ref({
  PageNo: 1,
  PageSize: 10,
  WareMaterialName: '',
  WareMaterialCode: '',
  CollectNo: '',
  Type: '',
  BatchNo: '',
  PurchaseNo: ''
});

//仓库类型列表
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取菜单列表
// const getTabelData = () => {
//     getStarvingRecord(formModel.value).then(res => {
//         if(res.code == 200) {
//             const {data} = res;
//             const result = data;
//             tableData.value = result.rows;
//             totalItems.value = result.totalRows;
//         }else {
//             ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
//         } 
//     }).catch(err => {
//         console.log(err)
//         ElMessage.error(err)
//     })
// }

// getTabelData();

//重置搜索
const resetForm = () => {
  formModel.value = {
    PageNo: 1,
    PageSize: 10,
    WareMaterialName: '',
    WareMaterialCode: '',
    CollectNo: '',
    Type: '',
    BatchNo: '',
    PurchaseNo: ''
  }
  getTabelData();
}

//选中的行
const checkRows = ref<{ id: number }[]>([]);

// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
}
//导出
const handExport = () => {
  const tHeader: string[] = Object.keys(checkRows.value[0]);
  const data = formatJson(tHeader, checkRows.value);
  exportJson2Excel(
    tHeader,
    data,
    "列表数据"
  );
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "物料编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.WareMaterialCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.WareMaterialCode) = $event)),
                        clearable: "",
                        placeholder: "请输入物料编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "物料名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.WareMaterialName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.WareMaterialName) = $event)),
                        clearable: "",
                        placeholder: "请输入物料名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "采购单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.PurchaseNo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.PurchaseNo) = $event)),
                        clearable: "",
                        placeholder: "请输入采购单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "业务类型:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.Type) = $event)),
                        clearable: "",
                        placeholder: "请输入业务类型"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "批次:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.BatchNo,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.BatchNo) = $event)),
                        clearable: "",
                        placeholder: "请输入批次"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_form, {
                "label-position": "left",
                "label-width": "180px",
                inline: "",
                class: "demo-table-expand"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "大类" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.category), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "小类" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.materialTypeName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "物料规格" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.specificationModel), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "尺寸(mm)" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(`${scope.row.long}*${scope.row.width}*${scope.row.high}`), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "单位" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.unit), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "重量" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.weight), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "收货人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdUserName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "收货日期" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "供应商" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.basicSupplierInfoName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "业务类型",
            prop: "type",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "物料编号",
            prop: "warematerialCode",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "物料名称",
            prop: "warematerialName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "批次",
            prop: "batchNo",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "缺货数量",
            sortable: "",
            prop: "uncollectedQuantity",
            width: "110",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "采购单号",
            prop: "purchaseNo",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "收货单号",
            prop: "collectNo",
            align: "center",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ], 64))
}
}

})